/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FufiPaymentStatus } from './FufiPaymentStatus';
import {
    FufiPaymentStatusFromJSON,
    FufiPaymentStatusFromJSONTyped,
    FufiPaymentStatusToJSON,
    FufiPaymentStatusToJSONTyped,
} from './FufiPaymentStatus';
import type { FufiContributionType } from './FufiContributionType';
import {
    FufiContributionTypeFromJSON,
    FufiContributionTypeFromJSONTyped,
    FufiContributionTypeToJSON,
    FufiContributionTypeToJSONTyped,
} from './FufiContributionType';
import type { FufiPaymentType } from './FufiPaymentType';
import {
    FufiPaymentTypeFromJSON,
    FufiPaymentTypeFromJSONTyped,
    FufiPaymentTypeToJSON,
    FufiPaymentTypeToJSONTyped,
} from './FufiPaymentType';

/**
 * 
 * @export
 * @interface FufiFinancialInfoMoneyIn
 */
export interface FufiFinancialInfoMoneyIn {
    /**
     * 
     * @type {string}
     * @memberof FufiFinancialInfoMoneyIn
     */
    id: string;
    /**
     * 
     * @type {FufiPaymentType}
     * @memberof FufiFinancialInfoMoneyIn
     */
    type: FufiPaymentType;
    /**
     * 
     * @type {FufiContributionType}
     * @memberof FufiFinancialInfoMoneyIn
     */
    contractContributionType: FufiContributionType;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoMoneyIn
     */
    amount: number;
    /**
     * 
     * @type {FufiPaymentStatus}
     * @memberof FufiFinancialInfoMoneyIn
     */
    status: FufiPaymentStatus;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoMoneyIn
     */
    applied: number;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoMoneyIn
     */
    balance: number;
    /**
     * 
     * @type {Date}
     * @memberof FufiFinancialInfoMoneyIn
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoMoneyIn
     */
    refunded?: number | null;
}



/**
 * Check if a given object implements the FufiFinancialInfoMoneyIn interface.
 */
export function instanceOfFufiFinancialInfoMoneyIn(value: object): value is FufiFinancialInfoMoneyIn {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('contractContributionType' in value) || value['contractContributionType'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('applied' in value) || value['applied'] === undefined) return false;
    if (!('balance' in value) || value['balance'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    return true;
}

export function FufiFinancialInfoMoneyInFromJSON(json: any): FufiFinancialInfoMoneyIn {
    return FufiFinancialInfoMoneyInFromJSONTyped(json, false);
}

export function FufiFinancialInfoMoneyInFromJSONTyped(json: any, ignoreDiscriminator: boolean): FufiFinancialInfoMoneyIn {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': FufiPaymentTypeFromJSON(json['type']),
        'contractContributionType': FufiContributionTypeFromJSON(json['contractContributionType']),
        'amount': json['amount'],
        'status': FufiPaymentStatusFromJSON(json['status']),
        'applied': json['applied'],
        'balance': json['balance'],
        'date': (new Date(json['date'])),
        'refunded': json['refunded'] == null ? undefined : json['refunded'],
    };
}

export function FufiFinancialInfoMoneyInToJSON(json: any): FufiFinancialInfoMoneyIn {
    return FufiFinancialInfoMoneyInToJSONTyped(json, false);
}

export function FufiFinancialInfoMoneyInToJSONTyped(value?: FufiFinancialInfoMoneyIn | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': FufiPaymentTypeToJSON(value['type']),
        'contractContributionType': FufiContributionTypeToJSON(value['contractContributionType']),
        'amount': value['amount'],
        'status': FufiPaymentStatusToJSON(value['status']),
        'applied': value['applied'],
        'balance': value['balance'],
        'date': ((value['date']).toISOString()),
        'refunded': value['refunded'],
    };
}

